// Client-side marketing attribution. Cookies/localStorage support attribution but the
// server re-resolves partner/campaign on lead creation (never the only method).
const KEY = "ra_attr";
const MAX_AGE_MS = 180 * 24 * 60 * 60 * 1000; // 180 days

export function storeAttribution({ campaign, source, channel, landing }) {
  if (!campaign && !source) return;
  try {
    localStorage.setItem(KEY, JSON.stringify({
      campaign: campaign || null, source: source || null,
      channel: channel || null, landing: landing || null, ts: Date.now(),
    }));
  } catch { /* ignore */ }
}

export function getAttribution() {
  try {
    const d = JSON.parse(localStorage.getItem(KEY));
    if (!d) return null;
    if (Date.now() - d.ts > MAX_AGE_MS) { localStorage.removeItem(KEY); return null; }
    return d;
  } catch { return null; }
}
